import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const AdvertiseCTASection = () => (
  <section className="py-20 bg-gradient-to-r from-[#DE92A9] via-[#E8AABC] to-[#DE92A9] relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&h=400&fit=crop&q=80")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      <h2
        className="text-3xl md:text-4xl text-white mb-6"
        style={{ fontFamily: '"Playfair Display", serif' }}
      >
        Are You a Wedding Vendor?
      </h2>
      <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
        Join Malta's most trusted wedding directory. Get featured in I DO Bridal Magazine
        and connect with thousands of engaged couples planning their special day.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/advertise" data-testid="view-advertising-packages-btn">
          <Button className="bg-white text-[#DE92A9] hover:bg-[#FAF9F7] px-8 py-4 text-sm tracking-wider">
            VIEW ADVERTISING PACKAGES
          </Button>
        </Link>
        <Link to="/contact" data-testid="contact-us-btn">
          <Button
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-[#DE92A9] px-8 py-4 text-sm tracking-wider"
          >
            CONTACT US
          </Button>
        </Link>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
        <div>
          <div
            className="text-3xl font-light mb-2"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            10K+
          </div>
          <div className="text-sm tracking-wider opacity-90">Monthly Readers</div>
        </div>
        <div>
          <div
            className="text-3xl font-light mb-2"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            97
          </div>
          <div className="text-sm tracking-wider opacity-90">Issues Published</div>
        </div>
        <div>
          <div
            className="text-3xl font-light mb-2"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            100+
          </div>
          <div className="text-sm tracking-wider opacity-90">Partner Vendors</div>
        </div>
      </div>
    </div>
  </section>
);

export default AdvertiseCTASection;
